import Pagination from "../../../components/pagination/Pagination";
import connect from "react-redux/es/connect/connect";
import { getVisits } from "../../../redux/actions/visitActions";
const mapStateToProps = (state, ownProps) => {
  return {
    page: state.visit.page,
    pages: state.visit.pages,
    pageSize: state.visit.pageSize,
    nbItems: state.visit.visits.length
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getNext: page => {
      const nextPage = page;
      dispatch(getVisits({ page: nextPage }));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Pagination);



// WEBPACK FOOTER //
// src/containers/activite/visit/PaginationContainer.js